(function () {
  /**
   * CELLFY — paginação numerada da coleção, 100% no navegador (sem
   * recarregar a página). Todos os produtos (até 250, já ordenados com
   * estoque primeiro) vêm na mesma página, marcados com
   * data-page-group="N" — só mostramos o grupo ativo por vez.
   *
   * Card escondido (display:none) não baixa imagem no navegador, então
   * isso continua leve pro mobile mesmo com todos os produtos no HTML.
   */
  function setupPagination(nav) {
    if (nav.dataset.cellfyInit === 'true') return;
    nav.dataset.cellfyInit = 'true';

    var grid = nav.closest('.product-grid-container')?.querySelector('.product-grid')
      || document.querySelector('.product-grid');
    if (!grid) return;

    var totalPages = parseInt(nav.dataset.totalPages, 10);
    var currentPage = 1;

    var prevBtn = nav.querySelector('.cellfy-pagination__link--prev');
    var nextBtn = nav.querySelector('.cellfy-pagination__link--next');
    var numberBtns = Array.prototype.slice.call(
      nav.querySelectorAll('.cellfy-pagination__link:not(.cellfy-pagination__link--prev):not(.cellfy-pagination__link--next)')
    );

    function showPage(page) {
      if (page < 1 || page > totalPages) return;
      currentPage = page;

      grid.querySelectorAll('[data-page-group]').forEach(function (item) {
        var group = parseInt(item.dataset.pageGroup, 10);
        item.style.display = group === currentPage ? '' : 'none';
      });

      numberBtns.forEach(function (btn) {
        btn.classList.toggle('is-current', parseInt(btn.dataset.cellfyPage, 10) === currentPage);
      });

      if (prevBtn) prevBtn.setAttribute('aria-disabled', currentPage === 1 ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', currentPage === totalPages ? 'true' : 'false');

      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    numberBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPage(parseInt(btn.dataset.cellfyPage, 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showPage(currentPage + 1);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-cellfy-pagination]').forEach(setupPagination);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();